export class ExpressionConstants {
    static IfThenExpressionType: string = "If Then";

    static MAX_CHARACTER_LENGTH_VIEW: number = 15;

    static EXPRESSION_CLEAR_COOKIE_KEY = "EXPRESSION_CLEAR_COOKIE_KEY";
}
